module.exports = __webpack_public_path__ + "img/note_w.0b503a62.svg";